export default {
  completeForm: {
    english: "Complete the Form",
    spanish: "Complete el siguiente formulario"
  }
};
